import { FormFields } from '@core/data-access/models/form/form-store.model';
import { setChangedFormFields } from '@core/utils/form-fields/form-field-pipes';
import {} from '@core/utils/form-fields/form-field-setters';
import { TariffUuid } from '@products/models/tariff.model';
import { filter, map, Observable, pipe, reduce } from 'rxjs';
import { TicketHolderForms } from '../models/ticket-assignment-store.model';
import { TicketHolderFormState, TicketHolderFormStates } from '../models/ticket-holder-form.model';
import {
  TicketHolderQuestionnaireFormState,
  TicketHolderQuestionnaireFormStates
} from '../models/ticket-holder-questionnaire-fom.model';

export const reduceTicketHolderFormStatePipe = () =>
  pipe(
    reduce((formStates: TicketHolderFormStates, formState: TicketHolderFormState & { tariffUuid: TariffUuid }) => {
      const { viewModel, dynamicFormFields, form, person, tariffUuid } = formState;

      formStates.set(tariffUuid, { viewModel, dynamicFormFields, person, form });

      return formStates;
    }, new Map())
  );

export const reduceTicketHolderQuestionnaireFormStatePipe = () =>
  pipe(
    reduce(
      (
        formStates: TicketHolderQuestionnaireFormStates,
        formState: TicketHolderQuestionnaireFormState & { tariffUuid: TariffUuid }
      ) => {
        const { viewModel, dynamicFormFields, form, person, tariffUuid } = formState;

        formStates.set(tariffUuid, { viewModel, dynamicFormFields, person, form });

        return formStates;
      },
      new Map()
    )
  );

export const updateFormFieldsFilterPipe = (
  previousTicketHolderFormChanges: TicketHolderForms,
  currentTicketHolderFormChanges: TicketHolderForms,
  filterFn: ({ tariffUuid, changedFormFields }: { tariffUuid: TariffUuid; changedFormFields: FormFields }) => boolean
) =>
  pipe<
    Observable<TariffUuid>,
    Observable<{ tariffUuid: TariffUuid; changedFormFields: FormFields }>,
    Observable<{ tariffUuid: TariffUuid; changedFormFields: FormFields }>
  >(
    map((tariffUuid: TariffUuid) => ({
      tariffUuid,
      changedFormFields: setChangedFormFields([
        previousTicketHolderFormChanges[tariffUuid]?.formFields,
        currentTicketHolderFormChanges[tariffUuid]?.formFields
      ])
    })),
    filter(filterFn)
  );
